
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inscription/lyceen",
      function () {
        return require("private-next-pages/inscription/lyceen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inscription/lyceen"])
      });
    }
  